// extracted by mini-css-extract-plugin
export default {"skeleton":"ImageRenderr_skeleton__Mybmk","shimmer":"ImageRenderr_shimmer__j8kEv","fallback":"ImageRenderr_fallback__DitOV"};